import type { JsonSchemaNode } from "@nmblr-platform-flow/schema";
import { humanize } from "../../../lib/humanize.js";

interface Props {
	name: string;
	schema: JsonSchemaNode;
	value: unknown;
	onChange: (value: unknown) => void;
	required?: boolean;
}

export function NumberInput({ name, schema, value, onChange, required }: Props) {
	const id = `field-${name}`;
	const numValue =
		typeof value === "number" ? value : ((schema.default as number | undefined) ?? "");
	return (
		<label className="mb-3 block" htmlFor={id}>
			<span className="text-xs text-text-muted">
				{humanize(name)}
				{required && <span className="ml-1 text-error">*</span>}
			</span>
			<input
				id={id}
				type="number"
				value={numValue}
				step={schema.type === "integer" ? 1 : "any"}
				onChange={(e) => {
					if (e.target.value === "") {
						onChange(undefined);
						return;
					}
					const parsed =
						schema.type === "integer"
							? Number.parseInt(e.target.value, 10)
							: Number.parseFloat(e.target.value);
					if (!Number.isNaN(parsed)) onChange(parsed);
				}}
				className="mt-1 block w-full rounded-xl border border-border bg-canvas px-3 py-2 text-xs text-text-primary focus:border-accent focus:ring-1 focus:ring-accent focus:outline-none"
			/>
			{schema.description && (
				<span className="mt-1 block text-xs text-text-muted">{schema.description}</span>
			)}
		</label>
	);
}
